import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { InfractionType } from '../domain/game-event';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  private url = environment.API_HOST + '/api/domains';

  constructor(private http: HttpClient) {}

  fetchInfractionTypes(): Observable<InfractionType[]> {
    return this.http
      .get<InfractionType[]>(`${this.url}/infraction-types`)
      .pipe(catchError(this.handleError));
  }

  private handleError(httpErrorResponse: HttpErrorResponse) {
    console.error(httpErrorResponse.error);
    return throwError(() => new Error(httpErrorResponse.error));
  }
}
